// eslint-disable-next-line no-shadow
export enum GiveABadgeView {
	Form = 'form',
	Confirmation = 'confirmation',
}
